import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';

function App() {
  return (
    <div className="App">
      <Navigation />
      <section id="hero">
        <Hero />
      </section>
      
      <section id="about" className="section">
        <div className="container">
          <h2 className="section-title">About</h2>
          <div className="section-content">
            <p className="section-text">
              Software is broken in its current form. Users and their data have become the product, 
              with zero transparency and a "break the rules, deal with consequences later" mentality 
              permeating the tech industry.
            </p>
            <p className="section-text">
              I set out to create the solutions I wanted to use—upfront software that gives users 
              exactly what they need and nothing that doesn't serve them. We're moving away from 
              ads, tracking, surveillance, addictive algorithms, and nefarious data collection.
            </p>
            <p className="section-text">
              Building ethical solutions to real problems creates software that users feel comfortable 
              and willing to pay for. This eliminates the perverse incentive to keep users on your 
              site as long as possible to consume more ads and generate more data.
            </p>
            <p className="section-text">
              At Silo Sphere, we believe in transparent, user-first development that respects privacy 
              and delivers genuine value. No hidden agendas, no data harvesting, just solutions that work.
            </p>
          </div>
        </div>
      </section>
      
      <section id="projects" className="section">
        <div className="container">
          <h2 className="section-title">Projects</h2>
          <div className="section-content">
            <div className="projects-grid">
              <div className="project-card">
                <h3 className="project-title">DailyBug</h3>
                <p className="project-description">
                  There has never been a news site I've had a good experience visiting. Covered in ads, 
                  paywalls, biased coverage, and obvious agendas being pushed. DailyBug leverages AI to 
                  solve all these issues—delivering clean, unbiased news summaries without the noise.
                </p>
                <a 
                  href="https://dailybug.news" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="project-link"
                >
                  Visit DailyBug →
                </a>
              </div>
              
              <div className="project-card">
                <h3 className="project-title">Silo Social</h3>
                <p className="project-description">
                  Social media's promise to connect everyone is a beautiful goal, but major platforms 
                  tell a different story. Silo Social creates a focused space for you and your family 
                  or close friends. Everything stays in the silo—no more posts from people you'll never 
                  meet. Build a close, connected hub for the people who actually matter in your life.
                </p>
                <div className="project-tech">
                  <span className="tech-tag">Coming Soon</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section id="contact" className="section">
        <div className="container">
          <h2 className="section-title">Contact</h2>
          <div className="section-content">
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <a href="mailto:brian@dailybug.news" className="contact-link">
                  brian@dailybug.news
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
